export * from './activeWatcher'
export * from './cacheRoute'
export * from './FileExport'
export * from './storageHelper'
export * from './validators'

export function buildOtherAppLink(appCode: string, path: string) {
  return '#/system/' + appCode + '/' + encodeURIComponent(path)
}
